<template>
  <div
    ref="drop"
    v-click-outside="closeEditor"
    :style="{
      top: coordinates.top,
      left: coordinates.left,
    }"
    :class="[$style.color_dropdown, dropToBottom ? '' : $style.dropdown_top]"
  >
    <div :class="[$style.dropdown_wrap]">
      <div
        v-for="option in options"
        :key="option.id"
      >
        <div
          :class="[$style.dropdown_item, value === option.id ? $style.dropdown_item_selected : '']"
          :style="{background: option.value}"
          @click="selectValue(option)"
        />
      </div>
    </div>
    <div
      v-if="value"
      :class="$style.reset_button"
      @click="unselect"
    >
      {{ locales('custom_column_recet_button_text') }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'GridCustomListCellEditor',
  props: {
    data: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  emits: [
    'selectColors',
  ],
  data() {
    return {
      value: +this.data,
      locales: __,
      coordinates: {
        left: 'auto',
        top: 'auto',
      },
      dropToBottom: true,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getCoordinates();
    });
  },
  methods: {
    handleChange(event) {
      this.value = event.target.value;
      this.$emit('selectColors', this.value);
    },
    unselect() {
      this.value = [];
      this.$emit('selectColors', this.value);
    },
    selectValue(item) {
      this.value = item.id;
      this.$emit('selectColors', this.value);
    },
    closeEditor() {
      this.$emit('selectColors', this.value);
    },
    getCoordinates() {
      const coordinates = this.placeholder.getBoundingClientRect();
      const clientHeight = document.documentElement.clientHeight;
      const elementHeight = this.$refs.drop.offsetHeight;
      const appFooter = 30;

      this.dropToBottom = (coordinates.bottom + elementHeight) < clientHeight - appFooter;

      if (this.dropToBottom) {
        this.coordinates = {
          top: `${coordinates.bottom + 1}px`,
          left: `${coordinates.left}px`,
        };
      } else {
        this.coordinates = {
          top: `${coordinates.top - elementHeight}px`,
          left: `${coordinates.left}px`,
        };
      }
    },
  },
};
</script>

<style module src="./colorPicker.less" lang="less"></style>
